var getBuiltIn = require('../internals/get-built-in');

module.exports = getBuiltIn('document', 'documentElement');



//////////////////
// WEBPACK FOOTER
// ./~/react-stickynode/~/core-js/internals/html.js
// module id = 1183
// module chunks = 0